import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Route} from 'react-router'

/**
 * Link that shows as selected when the route the link pertains to is active.
 */
class RouteLink extends Component {
	render() {
		const {className, path, to, children, activeOnlyWhenExact, disabled} = this.props;
		
		return (
			<Route
				path={path || to}
				exact={activeOnlyWhenExact}
				children={({match}) => disabled ? (
					<span className={`${className || ''} ${match ? 'selected' : ''}`}>{children}</span>
				) : (<Link to={to} className={`${className || ''} ${match ? 'selected' : ''}`}>{children}</Link>)}
			/>
		);
	}
}

export default RouteLink;


// WEBPACK FOOTER //
// ./src/widgets/RouteLink.js